(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gaia-header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let header = document.querySelector('.shopify-section gaia-header');
    let announcementBar = document.querySelector('.utility-bar');

    const updateHeights = () => {
      document.documentElement.style.setProperty('--header-height', `${parseInt(header.offsetHeight)}px`);
      if (announcementBar) {
        document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBar.offsetHeight}px`);
      }
    };

    updateHeights();

    var headerObserver = new ResizeObserver(updateHeights);
    headerObserver.observe(header);

    if (announcementBar) {
      headerObserver.observe(announcementBar);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
